<template>
    <div class="report-data-area-box">
        <div class="report-data-area" v-bind:id="canvasId"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportDataArea',
    props: ['canvasId', 'xTitle', 'xDataArr', 'yDataArr'],
    computed: {},
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initEcharts();
        }, 20);
    },
    methods: {
        initEcharts() {
            var me = this;
            var canvasDom = document.getElementById(this.canvasId);
            if(canvasDom == null) { return; }
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(canvasDom);
            // 绘制图表
            myChart.setOption({
                xAxis: {
                    type: 'category',
                    data: me.xDataArr,
                    name: me.xTitle,
                    nameLocation: 'start',
                    nameTextStyle: {
                        color: '#191919',
                        fontSize: 9,
                        align: 'left',
                        padding: [25, 0, 0, 0]
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#DBB272'
                        }
                    },
                    axisTick: {
                        alignWithLabel: true,
                        lineStyle: {
                            color: '#D8D8D8'
                        }
                    },
                    axisLabel: {
                        color: '#191919',
                        fontSize: 10
                    }
                },
                yAxis: {
                    type: 'value',
                    show: false
                },
                series: [{
                    data: me.yDataArr,
                    type: 'line',
                    symbol: 'emptyCircle',
                    symbolSize: 4,
                    smooth: true,
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0, y: 0,
                            x2: 0, y2: 1,
                            colorStops: [{
                                offset: 0, color: '#F43E39' // 0% 处的颜色
                            }, {
                                offset: 1, color: '#F9EDDF' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    }
                }]
            });
            // console.log('initEcharts------', this.canvasId, canvasDom, echarts)
        }
    }
}
</script>